import { type CSSProperties } from "react";
import { resolveIconBody, type IconName } from "./icons";

export interface IconProps {
  name: IconName;
  size?: number;
  color?: string;
  strokeWidth?: number;
  fill?: string;
  /** Decorative by default; pass a label to expose it to assistive tech. */
  title?: string;
  style?: CSSProperties;
}

/** Tabler icon rendered from a vendored SVG body. Color inherits via currentColor. */
export function Icon({
  name,
  size = 18,
  color = "currentColor",
  strokeWidth = 1.5,
  fill = "none",
  title,
  style,
}: IconProps) {
  const body = resolveIconBody(name);
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill}
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      role={title ? "img" : undefined}
      aria-label={title}
      aria-hidden={title ? undefined : true}
      style={{ display: "block", flexShrink: 0, color, ...style }}
      dangerouslySetInnerHTML={{ __html: body }}
    />
  );
}
